
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refleksi-kompetensi",
      function () {
        return require("private-next-pages/refleksi-kompetensi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refleksi-kompetensi"])
      });
    }
  